const RANKING = [
  { rank: 1, title: '星际穿越2：新纪元', category: '科幻', hot: 9856, trend: 'up', change: '+2' },
  { rank: 2, title: '命运之轮', category: '韩剧', hot: 8723, trend: 'up', change: '+5' },
  { rank: 3, title: '暗夜追踪', category: '悬疑', hot: 7690, trend: 'down', change: '-1' },
  { rank: 4, title: '龙之秘境', category: '动画', hot: 7234, trend: 'up', change: '+8' },
  { rank: 5, title: '绝地追击', category: '动作', hot: 6890, trend: 'up', change: '+3' },
];

const getRankStyle = (rank: number) => {
  if (rank === 1) return 'bg-accent-500 text-background-50';
  if (rank === 2) return 'bg-primary-500 text-background-950';
  if (rank === 3) return 'bg-secondary-500 text-background-50';
  return 'bg-background-300 text-foreground-400';
};

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50">热度榜单</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-xl mx-auto">
            实时热度排行，看看大家都在看什么
          </p>
        </div>
        <div className="max-w-2xl mx-auto">
          <div className="rounded-xl overflow-hidden bg-background-100 border border-background-300/30">
            {RANKING.map((item, i) => (
              <div
                key={item.rank}
                className={`flex items-center gap-4 p-4 md:p-5 ${
                  i < RANKING.length - 1 ? 'border-b border-background-300/20' : ''
                } hover:bg-background-200/50 transition-colors cursor-pointer`}
              >
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${getRankStyle(item.rank)}`}
                >
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-100 truncate">{item.title}</h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.category}</span>
                </div>
                <div className="flex items-center gap-1 flex-shrink-0">
                  <span className="text-xs font-semibold text-foreground-300 whitespace-nowrap">
                    {item.hot.toLocaleString()}
                  </span>
                  <span className="text-[10px] text-foreground-500">热度</span>
                </div>
                <div
                  className={`flex items-center gap-0.5 text-xs font-medium flex-shrink-0 whitespace-nowrap ${
                    item.trend === 'up' ? 'text-accent-400' : 'text-secondary-400'
                  }`}
                >
                  <i className={`${item.trend === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} text-xs`}></i>
                  {item.change}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}